export const pagesContainerMetaData = {
    fullWidth: false
}
